import { createAction } from '@reduxjs/toolkit';
import { createMmWsAction } from '@skynet/data-ws-mm';
import { AccountCommands } from './types';

export interface EnableAccountPayload {
  accountID: string;
  exchangeID?: number;
}

/** Sends `EnableAccount` over the MM channel; the accounts slice marks the update pending. */
export const enableAccount = createMmWsAction<EnableAccountPayload, EnableAccountPayload>(
  'accounts/enableAccount',
  (data) => ({
    command: AccountCommands.EnableAccount,
    ...data,
  }),
);

export interface DisableAccountPayload {
  accountID: string;
  exchangeID?: number;
}

/** Sends `DisableAccount` over the MM channel; the accounts slice marks the update pending. */
export const disableAccount = createMmWsAction<DisableAccountPayload>(
  'accounts/disableAccount',
  AccountCommands.DisableAccount,
);

export interface ListenPayload {
  /**
   * Backend listen section the domain entered, e.g. `overview`, `balances`. The slice does not
   * filter on it (the app dispatches only for sections that carry accounts); it is kept for tracing.
   */
  section: string;
}

export interface ListenMeta {
  /** `true` when this is the first listen for the section (a fresh load). */
  isInitCall?: boolean;
}

/**
 * Signals that a domain (loans or retainers) started listening to a section.
 *
 * It is a plain action, not a WS request: the domain's own `Listen` command already goes over the
 * wire, and this one only tells the accounts slice to show its loading state. The app dispatches
 * it for the domain listens of sections that carry accounts.
 */
export const listen = createAction(
  'sharedAccounts/listen',
  (payload: ListenPayload, meta: ListenMeta = {}) => ({ payload, meta }),
);

/** The account write actions, grouped for consumers that inject them as one object. */
export const accountsActions = { enableAccount, disableAccount };
